import type { FunctionComponent } from 'react';
import { currency } from '../../../../utils/currency';
import { titleCase } from '../../../../utils/strings';
import * as styles from './styles.module.scss';

type OrderSummaryProps = {
  items: number;
  orderTotal: number;
  shippingAddress: Record<string, unknown>;
};

const OrderSummary: FunctionComponent<OrderSummaryProps> = ({
  items,
  orderTotal,
  shippingAddress,
}) => {
  const { firstName, lastName, address1, address2, city, state, zipCode } = shippingAddress;
  const fullName = `${firstName} ${lastName}`;
  const shipTo1 = `${titleCase(address1)} ${titleCase(address2) || ''}`;
  const shipTo2 = `${titleCase(city)}, ${state} ${zipCode}`;

  return (
    <div className={styles.orderSummary} data-testid="order-summary-container">
      <div>
        <h3>Ship To</h3>
        <p>
          <span data-testid="order-summary-full-name">{fullName}</span>
        </p>
        <p data-testid="order-summary-address1">{shipTo1}</p>
        <p data-testid="order-summary-address2">{shipTo2}</p>
      </div>
      <div className={styles.row}>
        <div>
          <h3>Items</h3>
          <p data-testid="order-summary-total-items">{items}</p>
        </div>
        <div>
          <h3>Total</h3>
          <p data-testid="order-summary-total">{currency.format(orderTotal)}</p>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
